module.exports = __webpack_public_path__ + "static/Nanopesos1-c40aa7a416ec56530f7b999840f1fc4c.webp";